var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"letter-analytics"},[_c('v-container',[_c('div',{staticClass:"analytics-main analytics-main--full"},[_c('h1',{staticClass:"title-h2 text-sm-center mb-14"},[_vm._v("Карта кликов")]),_c('iframe',{ref:"map-frame",staticStyle:{"border-radius":"15px"},attrs:{"frameborder":"0","width":"100%","height":"0"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }